import { MaterialCommunityIcons } from '@expo/vector-icons';
import { Colors } from '@gripp/shared-ui';
import { StyleSheet, Text, View } from 'react-native';
import { ModalButton } from '../../shared/components/modalButton';
import { AddonAssignmentForm } from './addonAssignmentForm';

export const AddonRoutinesAssignmentButton = (data: any) => {
  return (
    <ModalButton
      label=""
      customButton={
        <View style={styles.routine}>
          <MaterialCommunityIcons
            name="format-list-checks"
            size={24}
            style={styles.routineIcon}
          />
          <Text style={styles.cellText}>{data.routinesCount || 0}</Text>
        </View>
      }
      modalComponent={({ onComplete }: { onComplete: () => void }) => (
        <AddonAssignmentForm
          addonId={data.addonId}
          title={data.addonName}
          onComplete={onComplete}
          initialTab="routines"
        />
      )}
      containerStyle={styles.modalContainer}
    />
  );
};

const styles = StyleSheet.create({
  routine: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  routineIcon: {
    marginRight: 6,
    color: Colors.blue,
  },
  cellText: {
    fontSize: 16,
    fontWeight: '500',
    flexWrap: 'nowrap',
  },
  modalContainer: {
    width: 640,
    height: '80%',
    minHeight: 450,
    alignSelf: 'center',
    backgroundColor: Colors.primaryGrayBackground,
    borderRadius: 10,
  },
});
